import moment from "moment";
import { AuditLogValues } from "state/request_details_dependencies";

const AuditLogTile: React.FC<{ log: AuditLogValues; index: number }> = ({ log, index }) => {
  const getStatusLabel = (statusCode: string | number | undefined) => {
    if (!statusCode) return "Unknown";
    return statusCode
      .toString()
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };
  return (
    <div
      key={index}
      style={{
        padding: "12px",
        backgroundColor: "#ffffff",
        borderRadius: "6px",
        borderLeft: "3px solid #D9D9D9",
      }}
    >
      <div
        style={{
          fontSize: "12px",
          fontWeight: 600,
          color: "#374151",
          marginBottom: "4px",
        }}
      >
        {getStatusLabel(log.action) +
          (() => { if (!log.name) return "";
          if (log.action === "REQUEST_UNDER_REVIEW" || !log.nextApproverAssigned) return ` (${log.name})`;
          return ` (${log.name} - ${log.nextApproverAssigned})`;
          })()}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: "12px",
          marginTop: "4px",
          color: "#6b7280",
        }}
      >
        <span>{moment(log.CreatedAt).format("MM-DD-YYYY")}</span>

        <span
          style={{
            margin: "0 6px",
            color: "#D9D9D9",
            fontWeight: 700,
          }}
        >
          •
        </span>

        <span style={{ color: "#9ca3af" }}>
          By: {log.actorName ? log.actorName : "Anonymous User"}
        </span>
      </div>
      <div style={{ marginTop: "6px", color: "#9ca3af", fontSize: "12px" }}>
        {log.chainName && getStatusLabel(log.action) === 'Request Approved' &&(
          <div>
            <strong>Chain:</strong> {log.chainName}
          </div>
        )}

        {log.chainUsers && log.chainUsers.length > 0 && getStatusLabel(log.action) === 'Request Assigned' && (
          <div style={{ marginTop: "4px" }}>
            <strong>Internal Project Admin:</strong>

            {log.chainUsers.map((user: any, i : any) => (
              <div key={i}>
                {user.first_name} {user.last_name} ({user.email})
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
export default AuditLogTile;
